// eslint-disable-next-line no-shadow
enum PixType {
  CPF,
  CELL,
  EMAIL,
  RANDOM,
}
export default PixType;
